import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {FormGroup,FormControl,FormBuilder, Validators} from '@angular/forms';
import { HpService } from 'projects/hp-api/src/lib/services/hp.service';

interface Visiteur {
  id:number;
  id_type:number;
  libelle: string;
  }
@Component({
  selector: 'app-sign-confirm',
  templateUrl: './sign-confirm.component.html',
  styleUrls: ['./sign-confirm.component.css']
})
export class SignConfirmComponent implements OnInit {
  slug :string;
  signForm: FormGroup;
  visiteurControl = new FormControl('', Validators.required);
  submitted = false;

  constructor(private hpService: HpService,private router: Router,public fb: FormBuilder) { }

  ngOnInit() {
    this.signForm = this.fb.group({
      visiteurName: ['', Validators.required]
  });
  
    this.slug = this.hpService.getSlug();

  }


}
